import { Button, Input, Modal } from 'antd';
import { useState } from 'react';

import { openNotification } from '../../common/helpers';
import { NotificationTypes } from '../../common/interfaces';
import { ChangePasswordDto } from '../../store/api/types.api';
import { userApi } from '../../store/api/user.api';
import { ChangePasswordForm } from './ChangePassword.types';
import { validatePassword } from './ChangePassword.utils';
import styles from './ChangePasswordModal.module.scss';

const initialFormData: ChangePasswordForm = {
  password: '',
  passwordRepeat: '',
};

interface IProps {
  isOpen: boolean;
  onCancel?: () => void;
}

const ChangePasswordModal = ({ isOpen, onCancel }: IProps): JSX.Element => {
  const [formData, setFormData] = useState<ChangePasswordForm>(initialFormData);

  const [changePassword, { isLoading }] = userApi.useChangePasswordMutation();

  const handleCancel = (): void => {
    onCancel?.();
  };

  const handleChangeInput =
    (name: keyof ChangePasswordForm) =>
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setFormData({ ...formData, [name]: e.target.value });
    };

  const handleSubmitForm = () => {
    if (formData.password !== formData.passwordRepeat) {
      openNotification(NotificationTypes.ERROR, 'Пароли не совпадают!');
      return;
    }

    if (!validatePassword(formData.password)) {
      openNotification(
        NotificationTypes.ERROR,
        'Пароль должен содержать не менее 6 символов на латинице и хотябы одну цифру!',
      );
      return;
    }

    const data: ChangePasswordDto = {
      password: formData.password,
    };
    changePassword(data)
      .then((data) => {
        openNotification(NotificationTypes.SUCCESS, 'Пароль успешно изменен!');
      })
      .catch((err) => {
        openNotification(
          NotificationTypes.ERROR,
          'Произошла ошибка при изменении пароля!',
        );
      });
  };

  return (
    <Modal
      width={370}
      open={isOpen}
      closable={false}
      footer={null}
      centered={true}
      onCancel={handleCancel}
    >
      <div className={styles['content']}>
        <h2>Для использования сервиса необходимо изменить пароль</h2>

        <div className={styles['content__input']}>
          <label>Введите новый пароль</label>
          <Input.Password
            size="large"
            placeholder="Новый пароль"
            onChange={handleChangeInput('password')}
          />
        </div>

        <div className={styles['content__input']}>
          <label>Повторите новый пароль</label>
          <Input.Password
            size="large"
            placeholder="Повторите пароль"
            onChange={handleChangeInput('passwordRepeat')}
          />
        </div>

        <div className={styles['buttons-group']}>
          <Button
            size="large"
            type="primary"
            htmlType="button"
            onClick={handleSubmitForm}
            loading={isLoading}
          >
            Изменить пароль
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ChangePasswordModal;
